import { useEffect } from "react";

export default function useBlockBackNavigation(message = "Back navigation is disabled.") {
  useEffect(() => {
    const handlePopState = () => {
      window.history.pushState(null, "", window.location.href);
      alert(message);
    };

    // Push current state once
    window.history.pushState(null, "", window.location.href);
    // Block back button
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [message]);
}
